// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-cropoverlay_container__19m9f","overlay":"idt-cropoverlay_overlay__2kung","svg":"idt-cropoverlay_svg__35qdh"};